import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {PaypalRequestsPage} from './components/PaypalRequestsPage';
import {LayoutSplashScreen, ContentRoute} from '../../../_metronic/layout';

export default function PaypalRequestsPageContainer() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/paypal-requests" component={PaypalRequestsPage}/>
      </Switch>
    </Suspense>
  );
}
